import React from 'react';

import {StyledPrimaryButton, StyledTransprentButton, StyledLoader} from './style';

export const PrimaryButton = ({children, loaderProps={}, isLoading=false, ...rest}) => {
    return (
        <StyledPrimaryButton {...rest}>
            {isLoading ? <StyledLoader  {...loaderProps} /> : children}
        </StyledPrimaryButton>
    )
}

export const TransprentButton = ({children,loaderProps={}, isLoading=false,  ...rest}) => {
    return (
        <StyledTransprentButton {...rest}>
             {isLoading ? <StyledLoader {...loaderProps} /> : children}
        </StyledTransprentButton>
    )
}